import { ApolloError } from 'apollo-boost';

export function getGqlErrorMessage(error: unknown) {
	let errorText = 'Unknown error';

	if (typeof error === 'string') {
		errorText = error;
	} else if (error instanceof ApolloError) {
		errorText = error.graphQLErrors?.[0]?.message ?? error.message;
	} else if (error instanceof Error) {
		errorText = error.message;
	}

	return errorText;
}
